import * as React from 'react';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector, change } from 'redux-form';
import { compose, withHandlers, withProps, lifecycle, withState } from 'recompose';
import { get } from 'lodash';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';
import { Player } from 'video-react';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { EditorField, Editor } from '@components/form';

import { Upload, UploadField } from '@components/form';
import * as T from '@modules/events/_eventsTypes';
import { getDraftContent, getEventFiles, updateDraftContent } from './_eventsActions';
import { Loader } from '@components/loader';
import { withNotifications } from '@components/hoc/withNotifications';

const enhance = compose<T.EventsFormProps, T.Outter & T.EventsFormProps & { eventId: string; setDisableSps: any }>(
  connect(
    state => ({
      files: formValueSelector('module-events')(state, 'files'),
      fileContent: formValueSelector('module-events-files')(state, 'draftContent'),
      fileRef: formValueSelector('module-events-files')(state, 'fileRef')
    }),
    dispatch => {
      return {
        changeFieldValue: value => dispatch(change('module-events', 'files', value)),
        changeDraftValue: value => dispatch(change('module-events-files', 'draftContent', value))
      };
    }
  ),
  withNotifications({ getEventFiles }),
  withState('loader', 'setLoader', false),
  withState('inProgress', 'setInProgress', false),
  withProps(({ initialValues }) => ({
    initialValues: {
      fileRefOld: initialValues
    },
    isDraft: get(initialValues, 'contentType', '') === 'text/draft',
    isWav: get(initialValues, 'contentType', '') === 'application/wav',
    fileId: get(initialValues, 'id', 'id-not-found')
  })),
  withHandlers({
    onSubmit: ({ changeFieldValue, closeItem, setDisableSps, getEventFilesNotify, eventId }) => async formData => {
      const eventFiles = await getEventFilesNotify(eventId);
      const fileRef = get(formData, 'fileRef');
      const newFiles = [...eventFiles, fileRef];
      if (fileRef) {
        changeFieldValue(newFiles);
      }

      setDisableSps(true);
      closeItem();
    },
    saveDraft: ({ eventId, fileId, fileContent, closeItem, setLoader }) => async () => {
      setLoader(true);
      const response = await updateDraftContent(eventId, fileId, fileContent);
      setLoader(false);
      if (response) {
        closeItem();
      }
    },
    onFileChange: ({ changeFieldValue, files }) => response => {
      const filesUpdated = files.map(f => (f.id === response.id ? response : f));
      changeFieldValue(filesUpdated);
    }
  }),
  lifecycle<any, any>({
    async componentDidMount() {
      const { isDraft, fileId, changeDraftValue, setLoader } = this.props;
      if (isDraft) {
        setLoader(true);
        const response: any = await getDraftContent(fileId);
        setLoader(false);
        changeDraftValue(response);
      }
    },
    componentWillReceiveProps({ fileRef }: any) {
      if (this.props.fileRef !== fileRef) {
        this.props.setInProgress(false);
      }
    },
    componentWillUnmount() {
      this.props.setInProgress(false);
    }
  }),
  reduxForm({
    form: 'module-events-files'
  })
);

const View: React.SFC<any> = ({
  handleSubmit,
  closeItem,
  isDraft,
  isWav,
  saveDraft,
  loader,
  fileRef,
  initialValues: { fileRefOld },
  onFileChange,
  inProgress,
  setInProgress
}) => {
  return (
    <div>
      {(loader || inProgress) && <Loader />}
      {isDraft && (
        <form>
          <Grid fluid={true}>
            <Row>
              <Col className="grid-system-margin" />
            </Row>

            <Row>
              <Col md={12}>
                <EditorField component={Editor} id="draftContent" name="draftContent" />
              </Col>
            </Row>
            <Row>
              <Col className="grid-system-margin" />
            </Row>
          </Grid>

          <Divider />

          <Button label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} onClick={saveDraft} />
          <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
        </form>
      )}
      <form className="layout" onSubmit={handleSubmit}>
        <Grid fluid={true}>
          <Row>
            <Col className="grid-system-margin" />
          </Row>

          <Row>
            <Col md={12}>
              <Row>
                <Col md={4}>
                  <h4>Soubor</h4>
                </Col>
                {fileRefOld &&
                  !fileRef && (
                    <Col md={4}>
                      {isWav && (
                        <Player
                          playsInline={true}
                          src={`/metropolis/api/ed/event/files/video/${get(fileRefOld, 'id')}/stream`}
                          fluid={false}
                          height={300}
                        />
                      )}
                      {!isWav && !isDraft && <UploadField component={Upload} name="fileRefOld" disabled={true} />}
                    </Col>
                  )}
                <Col md={fileRefOld ? 4 : 8}>
                  {isWav && (
                    <Player
                      playsInline={true}
                      src={`/metropolis/api/ed/event/files/video/${get(fileRef, 'id')}/stream`}
                      fluid={false}
                      height={300}
                    />
                  )}
                  {!isWav &&
                    !isDraft && (
                      <UploadField
                        component={Upload}
                        name="fileRef"
                        disabled={!!fileRef}
                        overwriteId={fileRefOld ? fileRefOld.id : null}
                        onChange={onFileChange}
                        onStart={() => setInProgress(true)}
                        onError={() => setInProgress(false)}
                        onAbort={() => setInProgress(false)}
                      />
                    )}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col className="grid-system-margin" />
          </Row>
        </Grid>

        <Divider />

        {!fileRefOld && (
          <Button
            type="submit"
            label="Uložit a zavřít"
            primary={true}
            disabled={!fileRef}
            style={{ margin: '16px 0 16px 16px' }}
          />
        )}
        <Button label={fileRefOld ? 'Zavřít' : 'Zrušit'} style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
      </form>
    </div>
  );
};

export const EventsFormFilesForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormFilesForm.tsx